"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchGetCommand = void 0;
const index_js_1 = require("../../../entity/actions/parsePaths/index.js");
const index_js_2 = require("../../../errors/index.js");
const consistent_js_1 = require("../../../options/consistent.js");
const rejectExtraOptions_js_1 = require("../../../options/rejectExtraOptions.js");
const tableName_js_1 = require("../../../options/tableName.js");
const index_js_3 = require("../../../table/index.js");
const isEmpty_js_1 = require("../../../utils/isEmpty.js");
const constants_js_1 = require("./constants.js");
class BatchGetCommand extends index_js_3.TableAction {
    constructor(table, entities = [], requests, options = {}) {
        super(table, entities);
        this[constants_js_1.$requests] = requests;
        this[constants_js_1.$options] = options;
    }
    requests(...requests) {
        const entities = [];
        const entityNames = new Set();
        for (const request of requests) {
            if (entityNames.has(request.entity.name)) {
                continue;
            }
            entities.push(request.entity);
            entityNames.add(request.entity.name);
        }
        return new BatchGetCommand(this.table, entities, requests, this[constants_js_1.$options]);
    }
    options(nextOptions) {
        return new BatchGetCommand(this.table, this[index_js_3.$entities], this[constants_js_1.$requests], nextOptions);
    }
    params() {
        var _a;
        if (this[constants_js_1.$requests] === undefined || this[constants_js_1.$requests].length === 0) {
            throw new index_js_2.DynamoDBToolboxError('actions.incompleteAction', {
                message: 'BatchGetCommand incomplete: No BatchGetRequest supplied'
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstRequest = this[constants_js_1.$requests][0];
        const firstRequestEntity = firstRequest.entity;
        const { consistent, attributes: _attributes, tableName, ...extraOptions } = (_a = this[constants_js_1.$options]) !== null && _a !== void 0 ? _a : {};
        (0, rejectExtraOptions_js_1.rejectExtraOptions)(extraOptions);
        if (tableName) {
            (0, tableName_js_1.parseTableNameOption)(tableName);
        }
        const attributes = _attributes;
        let projectionExpression = undefined;
        const expressionAttributeNames = {};
        /**
         * @debt feature "For now, we compute the projectionExpression using the first entity. Will probably use Table schemas once they exist."
         */
        if (attributes !== undefined) {
            const { entityAttributeName } = firstRequestEntity;
            const { ExpressionAttributeNames: projectionExpressionAttributeNames, ProjectionExpression } = firstRequestEntity
                .build(index_js_1.EntityPathParser)
                .parse(
            // entityAttributeName is required at all times for formatting
            attributes.includes(entityAttributeName)
                ? attributes
                : [entityAttributeName, ...attributes])
                .toCommandOptions();
            Object.assign(expressionAttributeNames, projectionExpressionAttributeNames);
            projectionExpression = ProjectionExpression;
            // table partitionKey and sortKey are required at all times for response re-ordering
            const { partitionKey, sortKey } = this.table;
            const filteredAttributes = new Set(Object.values(expressionAttributeNames));
            if (!filteredAttributes.has(partitionKey.name)) {
                projectionExpression += `, #_pk`;
                expressionAttributeNames['#_pk'] = partitionKey.name;
            }
            if (sortKey !== undefined && !filteredAttributes.has(sortKey.name)) {
                projectionExpression += `, #_sk`;
                expressionAttributeNames['#_sk'] = sortKey.name;
            }
        }
        const keys = [];
        for (const request of this[constants_js_1.$requests]) {
            const key = request.params();
            keys.push(key);
        }
        return {
            [tableName !== null && tableName !== void 0 ? tableName : this.table.getName()]: {
                Keys: keys,
                ...(consistent !== undefined ? { ConsistentRead: (0, consistent_js_1.parseConsistentOption)(consistent) } : {}),
                ...(projectionExpression !== undefined
                    ? { ProjectionExpression: projectionExpression }
                    : {}),
                ...(!(0, isEmpty_js_1.isEmpty)(expressionAttributeNames)
                    ? { ExpressionAttributeNames: expressionAttributeNames }
                    : {})
            }
        };
    }
}
exports.BatchGetCommand = BatchGetCommand;
BatchGetCommand.actionName = 'batchGet';
